module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Chair#2-a189299624954dbc033848dff9d42e92.svg";